import { IPathfindingHeuristic } from "./IPathfindingHeuristic";
import { PathfindingGraph } from "./PathfindingGraph";

/**
 * A heuristic that nudges the pathfinder search into the direction of a single target node, utilizing euclidian distance estimation.
 * <p>It's the most precise heuristic, yet slow due to the square root. Use the Manhattan Heuristic for 4-way or 8-way graphs.</p>
 * @author npuschke
 *
 */
export class PathfindingHeuristicEuclidian implements IPathfindingHeuristic {
    private _targetX: number = 0;
    private _targetY: number = 0;

    /**
     * Creates a heuristic that nudges the search towards the given target coordinates, using euclidian distance estimation.
     * @param targetX The horizontal coordinate of the target node.
     * @param targetY The vertical coordinate of the target node.
     *
     */
    constructor(targetX: number, targetY: number) {
        this._targetX = targetX;
        this._targetY = targetY;
    }

    /**
     * Calculates the heuristic value at the given coordinates.
     * @param graph The graph that is being searched.
     * @param x The horizontal coordinate of the node to be calculated.
     * @param y The vertical coordinate of the node to be calculated.
     * @return The heuristic value of the node.
     */
    public calculate(graph: PathfindingGraph, x: number, y: number): number {
        return (Math.sqrt(((this._targetX - x) * (this._targetX - x)) + ((this._targetY - y) * (this._targetY - y)))) * graph.traverseCostStandard;
    }
}


